import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { useTranslation } from 'react-i18next';
import i18n from '@/lib/i18n';

function getFaqItems() {
    return [
        {
            id: 'faq1',
            question: i18n.t('tokens:commentUtiliserMesJetons'),
            answer: i18n.t('tokens:chaqueJetonPermetDePrendreUnePhotoHorodatee'),
        },
        {
            id: 'faq2',
            question: i18n.t('tokens:lesJetonsExpirentIls'),
            answer: i18n.t('tokens:nonVosJetonsNExpirentJamaisVousPouvez'),
        },
        {
            id: 'faq3',
            question: i18n.t('tokens:puisJeObtenirUnRemboursement'),
            answer: i18n.t('tokens:lesJetonsNonUtilisesPeuventEtreRemboursesDans'),
        },
        {
            id: 'faq4',
            question: i18n.t('tokens:commentRecevoirMaFacture'),
            answer: i18n.t('tokens:votreFactureEstAutomatiquementEnvoyeeParEmailApr'),
        },
        {
            id: 'faq5',
            question: i18n.t('tokens:queContientUnCertificat'),
            answer: i18n.t('tokens:chaqueCertificatContientLaDateLHeurePrecise'),
        },
    ];
}

export default function SheetTokensFaq({ open, onClose }) {
    const { t } = useTranslation();
    const faqItems = getFaqItems();
    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <SheetContent className="w-[90vw] md:w-[500px]! md:max-w[500px]! flex flex-col p-0">
                <SheetHeader className="px-6 py-4 border-b border-border">
                    <SheetTitle className="text-lg font-semibold text-foreground">{t('tokens:questionsFrequentes')}</SheetTitle>
                </SheetHeader>

                <div className="flex-1 overflow-y-auto px-6 py-4">
                    <Accordion type="single" collapsible className="w-full">
                        {faqItems.map((faq) => (
                            <AccordionItem key={faq.id} value={faq.id} className="border-b border-border">
                                <AccordionTrigger className="text-sm font-medium text-foreground hover:no-underline py-4">
                                    {faq.question}
                                </AccordionTrigger>
                                <AccordionContent className="text-sm text-muted-foreground">
                                    {faq.answer}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </SheetContent>
        </Sheet>
    );
}
